import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { VideoLogService } from '../../../services/video-log.service';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-video-log-info-ng',
    templateUrl: './video-log-info.component.html',
    styleUrls: ['../../sharedStyles/base.scss', './video-log-info.component.scss']
})
export class VideoLogInfoComponent extends BaseComponent implements AfterViewInit, OnDestroy {
    jurisMap = {
        1: 'State',
        2: 'Turnpike',
        3: 'Agency Owned',
        5: 'Non-State Federal Aid Roads',
        6: 'Toll Bridges',
        8: 'Local Roads'
    };
    @Output() public readonly refreshInfo = this.videoLogService.refreshInfo;

    private readonly unsubscribe$ = new Subject<void>();
    constructor(
        _vcf: ViewContainerRef,
        public readonly videoLogService: VideoLogService,
        private readonly cdr: ChangeDetectorRef
    ) {
        super(_vcf, true);
    }

    ngAfterViewInit() {
        this.videoLogService.newOffset.pipe(
            takeUntil(this.unsubscribe$),
            distinctUntilChanged()
        ).subscribe(_ => {
            this.cdr.detectChanges();
        });

        this.videoLogService.newPlayerState.pipe(
            takeUntil(this.unsubscribe$),
            distinctUntilChanged()
        ).subscribe(_ => {
            this.cdr.detectChanges();
        });

        this.videoLogService.refreshInfo.subscribe(() => {
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
